var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-toolbar",
        {
          staticClass: "darken-1",
          attrs: { dense: "", flat: "", color: "white" }
        },
        [
          _c("v-toolbar-title", [_vm._v("\n      Load Defaults\n    ")]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-toolbar-items",
            [
              _c(
                "v-btn",
                {
                  staticClass: "primary lighten-1",
                  attrs: { loading: _vm.loadingBtn },
                  on: { click: _vm.saveLoadRequirements }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { column: "" } },
                    [
                      _c("v-icon", [_vm._v("save")]),
                      _vm._v("\n          Save\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        [
          _c(
            "v-card",
            { staticClass: "ml-2 mr-2", attrs: { height: "100%" } },
            [
              _c(
                "v-list",
                { attrs: { "two-line": "" } },
                [
                  _c(
                    "v-list-tile",
                    [
                      _c(
                        "v-list-tile-action",
                        [
                          _c("v-checkbox", {
                            model: {
                              value: _vm.requireDeliveryPaperwork,
                              callback: function($$v) {
                                _vm.requireDeliveryPaperwork = $$v
                              },
                              expression: "requireDeliveryPaperwork"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-content",
                        [
                          _c("v-list-tile-title", { staticClass: "pb-1" }, [
                            _vm._v(
                              "\n              Require Load " +
                                _vm._s(_vm.$t("terms.bill-of-lading")) +
                                "\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-action-text",
                            { staticClass: "mt-1 pt-1" },
                            [
                              _vm._v(
                                "if unchecked, uploading delivery paperwork is not required to complete loads"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-list-tile-action-text", [
                            _vm._v("can be set at load creation")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-action",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                small: "",
                                fab: "",
                                flat: "",
                                color: "primary"
                              },
                              on: {
                                click: function($event) {
                                  _vm.requireDeliveryPaperwork = !_vm.requireDeliveryPaperwork
                                }
                              }
                            },
                            [
                              !_vm.requireDeliveryPaperwork
                                ? _c("v-icon", { attrs: { disabled: "" } }, [
                                    _vm._v("check_circle_outline")
                                  ])
                                : _c("v-icon", [_vm._v("check_circle")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-165ceff8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-165ceff8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Sections/ChecklistSection.vue
// module id = null
// module chunks = 